<template>

  <div>

      <Content id="users">
        <div slot="search">
          <Search :model="search" :elem="searchElem" :btn-loading="list.loading" @on-search="handleDataList" />
        </div>

        <!-- .toolbar -->
        <ITable ref="list" stripe :columns="columns" :loading="list.loading" :data="list.data" :total="list.total"
                @on-page-change="handleDataList"/>
        <!-- ITable -->

      </Content>
  </div>

</template>
<script>
import {
  _roleUserByPages // 列表
} from "@/services/manage/users";
export default {
  name: "Users",
  data() {
    return {
      // 表单数据
      search: {
        name: ""
      },
      userWindow: false,
      title: "用户列表",
      roleId: "",
      // 列表属性
      list: {
        data:[], // 结构化数据
        current: 1,
        pageSize: 10,
        total: 0, // 数据总数
        loading: false // 加载状态
      },
      // 表单元素
      searchElem: [
        {
          label: '用户名',
          labelWidth: 80,
          prop: "name",
          placeholder: "",
          icon: "md-search"
        },
      ],
      // 表格列的配置描述
      columns: [
        {
          title: "用户id",
          key: "id",
          minWidth: 80
        },
        {
          title: "用户名",
          key: "name",
          minWidth: 80
        },
        {
          title: "真实姓名",
          key: "realName",
          minWidth: 80
        },
        {
          title: "操作员",
          key: "operator",
          minWidth: 80
        }, {
          title: "创建时间",
          key: "createTime",
          minWidth: 80
        }, {
          title: "状态",
          key: "status",
          minWidth: 80,
          render: (h, params) =>
            h('span', params.row.status === 1 ? "启用" : "禁用")
        }
      ]
    };
  },
  methods: {
    openWindow(title, row){
      this.userWindow = true;
      this.roleId = row.id;
      this.title = title;

      this.handleDataList();
    },
    /**
     * 获取用户列表
     * @param  {string} type 是否使用搜索, 默认值 undefined (不使用搜索)
     */
    handleDataList(e, type) {
      this.$Loading.start();
      //this.list.loading = true; // 列表加载状态
      const page = this.$refs["list"].handlePage(type); // 获取分页信息
      _roleUserByPages({
          ...this.search,
          roleId: this.roleId,
          currentPage: page.current,
          pageSize: page.pageSize
        }).then(res => {
            this.$Loading.finish();
            const { records, total } = res.data;
            this.list = {
              data: records,
              total: total,
              loading: false
            };
          })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
    },
  }
};
</script>
<style lang="postcss" scoped>
.toolbar {
  margin-bottom: 24px;
  text-align: right;

  & .number {
    margin-right: 8px;
  }
}
</style>
